// Marionette.extend
// -----------------

import Backbone from 'backbone';

// Borrow the Backbone `extend` method so we can use it as needed
const extend = Backbone.Model.extend;

export default extend;
